import { createContext } from 'react';

// React Context is a way to manage state globally.
export const CartContext = createContext();
